import React from 'react';

import Text from 'components/Text';
import { ITableModel } from 'components/Table/interface';
import { Visibility } from 'components/Visibility';

import { CTeStockState, enumLabelExpirationDayStock } from 'models/CTEs';

import { StatusDaysToExpire } from '../styles';

const labelLot = {
  label: 'Lote',
  key: 'lot',
  size: 90,
  maxSize: 90,
};

const labelSupplierProductCode = {
  label: 'Cód. Cliente',
  key: 'supplierProductCode',
  size: 90,
  maxSize: 90,
  noFilter: true
};

const labelSupplierProductDescription = {
  label: 'Produto',
  key: 'productDescription',
  size: 290,
  maxSize: 290,
  noFilter: true
};

const labelProductCode = {
  label: 'Cód. Viveo',
  key: 'productCode',
  size: 90,
  maxSize: 90,
  noFilter: true
};

const labelProductDescription = {
  label: 'Produto Viveo',
  key: 'supplierProductDescription',
  size: 290,
  maxSize: 290,
  noFilter: true
};

const labelManufacturingDate = {
  label: 'Dt. de Fabricação ',
  key: 'manufacturingDate',
  type: 'date',
  size: 110,
  maxSize: 110,
};

const labelDueDate = {
  label: 'Dt. de Validade',
  key: 'expirationDate',
  type: 'date',
  size: 110,
  maxSize: 110,
};

const labelDaysToExpire = {
  label: 'Validade',
  key: 'daysToExpire',
  size: 150,
  noFilter: true,
  Component: (data: CTeStockState) => (
    <>
      <Visibility visible={data.daysToExpire !== enumLabelExpirationDayStock.Ok}>
        <StatusDaysToExpire variant={data.daysToExpire} />
      </Visibility>
      <Text className="color-blue-gray first-letter-uppercase" size={12} showTip>
        {data.daysToExpireLabel}
      </Text>
    </>
  )
};

const labelBalanceAvailable = {
  label: 'Quantidade',
  key: 'balanceAvailable',
  size: 100,
  maxSize: 100
};


const cteModelItems: Array<ITableModel> = [
  labelLot,
  labelSupplierProductCode,
  labelSupplierProductDescription,
  labelProductCode,
  labelProductDescription,
  labelManufacturingDate,
  labelDueDate,
  labelBalanceAvailable,
  labelDaysToExpire
];

const cteStockItemsModel = () => {
  const model: Array<ITableModel> = [
    ...cteModelItems
  ];

  return model;
};


export {
  cteStockItemsModel
};